import { createContext, useContext, useState } from "react";

const translations = {
  nl: {
    nav: { experience: "Ervaring", included: "All-inclusive", menu: "Menu", bar: "Bar", practical: "Praktisch", book: "Boek nu" },
    hero: {
      tag: "Beach BBQ-ervaring",
      kicker: "Curaçao · elke woensdag & zondag",
      l1: "VUUR", l2: "ZEE", l3: "SUNSET",
      sub: "Een complete strand-barbecue: mixed grill van houtskool, welkomsthapjes, cocktails, DJ-beats en een duik in de Caribische zee — van middag tot gouden uur.",
      cta: "Reserveer je plek",
      badge: "€75 p.p. · all-inclusive",
      cap: "max. 30 gasten per avond",
      next: "Volgende edities",
    },
    marquee: ["MIXED GRILL", "MORO-RIJST", "SUNSET BEATS", "GEBAKKEN BANAAN", "CARIBBEAN VIBES", "MAX 30 GASTEN", "WOENSDAG & ZONDAG"],
    included: {
      kicker: "All-inclusive",
      title: "Één ticket. De hele avond.",
      price: "€75",
      per: "per persoon",
      extras: "Extra drankjes en een tweede BBQ-plate bestel je op locatie.",
      items: [
        { tag: "01", title: "Volle BBQ-plate", desc: "Mixed grill, moro-rijst, gebakken banaan, maïs, salade, brood en patat." },
        { tag: "02", title: "Welkomsthapjes", desc: "Ontvangst onder de palmen met hapjes vóór de barbecue." },
        { tag: "03", title: "1 cocktail", desc: "Of een andere alcoholische drank naar keuze bij aankomst." },
        { tag: "04", title: "3 frisdranken", desc: "Drie frisse drankjes inbegrepen — zoals Coco Rico, dé Curaçaose klassieker." },
        { tag: "05", title: "DJ & zonsondergang", desc: "Sunset beats terwijl de zon in de zee zakt." },
        { tag: "06", title: "Strand & zwemmen", desc: "Duik in de Caribische zee en relax op het zand." },
        { tag: "07", title: "Polar & extra's", desc: "Ijskoude Polar-biertjes en meer bestel je op locatie." },
      ],
    },
    menu: {
      kicker: "De BBQ-plate",
      title: "Vers van de houtskoolgrill",
      sub: "Alles wordt ter plaatse gegrild en op jouw bord samengesteld.",
      items: [
        { name: "Mixed Grill", desc: "Smeuïg gegrild premium vlees & kip gemarineerd in Caribische kruiden" },
        { name: "Gebakken Banaan", desc: "Zoete gekaramelliseerde rijpe bakbanaan" },
        { name: "Knapperige Patat", desc: "Goudgeel gebakken verse friet met huisgemaakte saus" },
        { name: "Gegrilde Maïs", desc: "Zoete maïskolf van de houtskoolgrill met kruidenboter" },
        { name: "Caribische Salade", desc: "Frisse rauwkostsalade met tropische dressing" },
        { name: "Brood & Kruidenboter", desc: "Vers gebakken brood met romige knoflook-kruidenboter" },
        { name: "Moro-Rijst", desc: "Traditionele gekruide rijst met zwarte bonen en Caribische aroma's" },
      ],
    },
    bar: {
      kicker: "De bar",
      title: "Drankenkaart",
      note: "Extra drankjes bestel je op locatie · richtprijzen",
      groups: [
        { name: "Bier", items: [{ name: "Polar Pilsener", price: "€3,50" }, { name: "Heineken", price: "€4,00" }, { name: "Polar Light", price: "€3,50" }] },
        { name: "Frisdrank", items: [{ name: "Coco Rico", price: "€3,00" }, { name: "Chubby", price: "€2,50" }, { name: "Supermalt", price: "€3,50" }, { name: "Water", price: "€2,50" }] },
        { name: "Wijn", items: [{ name: "Huiswijn rood / wit", price: "€5,00" }, { name: "Rosé", price: "€5,50" }, { name: "Prosecco", price: "€6,50" }] },
        { name: "Cocktails", items: [{ name: "Blue Curaçao", price: "€8,50" }, { name: "Piña Colada", price: "€8,50" }, { name: "Mojito", price: "€8,50" }] },
      ],
    },
    journey: {
      kicker: "Zo voelt de avond",
      title: "Van welkom tot zonsondergang",
      steps: [
        { time: "15:30", tag: "Welkom", title: "Aankomst op het strand", desc: "Ontvangst met welkomsthapjes en gekoelde drankjes onder de palmen." },
        { time: "16:30", tag: "Smaakexplosie", title: "De volle BBQ-plate", desc: "Vers gegrilde mixed grill, moro-rijst, gebakken banaan, patat en frisse salade." },
        { time: "18:00", tag: "Vibes & dip", title: "Muziek & zwemmen", desc: "Een verfrissende duik in de Caribische zee op de beats van onze DJ." },
        { time: "19:15", tag: "Magie", title: "Golden hour", desc: "De spectaculaire Curaçaose zonsondergang met een cocktail in de hand." },
      ],
    },
    booking: {
      kicker: "Reserveren",
      title: "Claim je plek aan het strand",
      step1: "1 · Kies je avond",
      step2: "2 · Aantal gasten",
      step3: "3 · Jouw gegevens",
      seatsLeft: "plekken vrij",
      soldOut: "Uitverkocht",
      guests: "gasten",
      name: "Naam",
      email: "E-mailadres",
      phone: "Telefoon (optioneel)",
      dietary: "Dieetwensen (optioneel)",
      total: "Totaal",
      perPerson: "€75 per persoon",
      pay: "Naar betaling",
      processing: "Bezig…",
      note: "Gratis annuleren tot 48 uur vooraf. Veilig betalen via Stripe (kaart, iDEAL, Apple Pay).",
      cancelledToast: "Betaling geannuleerd — je plek is nog niet gereserveerd.",
      errorToast: "Er ging iets mis. Probeer het opnieuw.",
      fillToast: "Vul je naam en een geldig e-mailadres in.",
    },
    practical: {
      kicker: "Praktisch",
      title: "Goed om te weten",
      location: "Locatie",
      locationVal: "Jan Thiel Beach, Curaçao",
      times: "Dagen & tijden",
      timesVal: "Woensdag & zondag · 15:30 – ±20:30",
      dress: "Dresscode",
      dressVal: "Casual beachwear — neem zwemkleding mee",
      contact: "Contact",
      email: "hello@curacaobeachbbq.com",
      whatsapp: "WhatsApp ons",
      faqTitle: "Veelgestelde vragen",
      faq: [
        { q: "Wat bij slecht weer?", a: "Dan verplaatsen we je boeking kosteloos naar een volgende editie, of je krijgt het volledige bedrag terug." },
        { q: "Kan ik annuleren?", a: "Ja, gratis tot 48 uur vooraf. Daarna kunnen we helaas niet meer terugbetalen." },
        { q: "Zijn kinderen welkom?", a: "Zeker! De sfeer is familievriendelijk — neem zwemspullen mee." },
        { q: "Dieet of allergie?", a: "Geef het door bij je boeking, de grillmeister houdt er rekening mee." },
        { q: "Parkeren?", a: "Gratis parkeren op loopafstand van het strand." },
      ],
    },
    footer: {
      tag: "Beach BBQ-ervaring op Curaçao. Vuur, zee en zonsondergang.",
      rights: "© 2026 Curaçao Beach Barbecue. Alle rechten voorbehouden.",
      music: "Muziek: “No Frills Salsa” — Kevin MacLeod, incompetech.com (CC BY 3.0)",
    },
    music: { label: "Salsa" },
    success: {
      verifying: "Betaling controleren…",
      pending: "We wachten nog op je betalingsbevestiging. Vernieuw de pagina over een minuut.",
      title: "Boeking bevestigd",
      sub: "Toon deze pas bij aankomst op het strand.",
      code: "Boekingscode",
      date: "Datum",
      guests: "Gasten",
      name: "Naam",
      total: "Totaal betaald",
      print: "Print of bewaar",
      home: "Terug naar home",
    },
  },
  en: {
    nav: { experience: "Experience", included: "All-inclusive", menu: "Menu", bar: "Bar", practical: "Practical", book: "Book now" },
    hero: {
      tag: "Beach BBQ experience",
      kicker: "Curaçao · every Wednesday & Sunday",
      l1: "FIRE", l2: "SEA", l3: "SUNSET",
      sub: "A complete beach barbecue: charcoal mixed grill, welcome bites, cocktails, DJ beats and a swim in the Caribbean sea — from afternoon to golden hour.",
      cta: "Reserve your spot",
      badge: "€75 p.p. · all-inclusive",
      cap: "max. 30 guests per evening",
      next: "Upcoming editions",
    },
    marquee: ["MIXED GRILL", "MORO RICE", "SUNSET BEATS", "FRIED PLANTAIN", "CARIBBEAN VIBES", "MAX 30 GUESTS", "WEDNESDAY & SUNDAY"],
    included: {
      kicker: "All-inclusive",
      title: "One ticket. The whole evening.",
      price: "€75",
      per: "per person",
      extras: "Extra drinks and a second BBQ plate can be ordered on location.",
      items: [
        { tag: "01", title: "Full BBQ plate", desc: "Mixed grill, moro rice, fried plantain, corn, salad, bread and fries." },
        { tag: "02", title: "Welcome bites", desc: "A warm welcome under the palms with snacks before the barbecue." },
        { tag: "03", title: "1 cocktail", desc: "Or another alcoholic drink of your choice on arrival." },
        { tag: "04", title: "3 soft drinks", desc: "Three refreshing drinks included — like Coco Rico, the Curaçao classic." },
        { tag: "05", title: "DJ & sunset", desc: "Sunset beats as the sun drops into the sea." },
        { tag: "06", title: "Beach & swim", desc: "Dive into the Caribbean sea and relax on the sand." },
        { tag: "07", title: "Polar & extras", desc: "Ice-cold Polar beers and more can be ordered on location." },
      ],
    },
    menu: {
      kicker: "The BBQ plate",
      title: "Fresh off the charcoal grill",
      sub: "Everything is grilled on site and plated your way.",
      items: [
        { name: "Mixed Grill", desc: "Tender grilled premium meats & chicken marinated in Caribbean spices" },
        { name: "Fried Plantain", desc: "Sweet caramelized ripe golden plantains" },
        { name: "Crispy Fries", desc: "Golden crispy fries served with signature dip" },
        { name: "Grilled Corn", desc: "Charcoal grilled sweet corn on the cob with herb butter" },
        { name: "Caribbean Salad", desc: "Fresh garden salad with a zesty tropical citrus dressing" },
        { name: "Bread & Herb Butter", desc: "Artisanal fresh bread served with creamy garlic herb butter" },
        { name: "Moro Rice", desc: "Traditional seasoned rice with black beans and savory aromatics" },
      ],
    },
    bar: {
      kicker: "The bar",
      title: "Drinks menu",
      note: "Extra drinks can be ordered on location · indicative prices",
      groups: [
        { name: "Beer", items: [{ name: "Polar Pilsener", price: "€3.50" }, { name: "Heineken", price: "€4.00" }, { name: "Polar Light", price: "€3.50" }] },
        { name: "Soft drinks", items: [{ name: "Coco Rico", price: "€3.00" }, { name: "Chubby", price: "€2.50" }, { name: "Supermalt", price: "€3.50" }, { name: "Water", price: "€2.50" }] },
        { name: "Wine", items: [{ name: "House wine red / white", price: "€5.00" }, { name: "Rosé", price: "€5.50" }, { name: "Prosecco", price: "€6.50" }] },
        { name: "Cocktails", items: [{ name: "Blue Curaçao", price: "€8.50" }, { name: "Piña Colada", price: "€8.50" }, { name: "Mojito", price: "€8.50" }] },
      ],
    },
    journey: {
      kicker: "How the evening feels",
      title: "From welcome to sunset",
      steps: [
        { time: "3:30 PM", tag: "Welcome", title: "Arrival at the beach", desc: "Welcome bites and ice-cold drinks under the palm trees." },
        { time: "4:30 PM", tag: "Flavor burst", title: "The full BBQ plate", desc: "Freshly grilled mixed grill, moro rice, fried plantain, fries and salad." },
        { time: "6:00 PM", tag: "Vibes & dip", title: "Music & swimming", desc: "A refreshing dive into the Caribbean sea to the beats of our DJ." },
        { time: "7:15 PM", tag: "Magic", title: "Golden hour", desc: "The spectacular Curaçao sunset with a cocktail in hand." },
      ],
    },
    booking: {
      kicker: "Reservations",
      title: "Claim your spot on the beach",
      step1: "1 · Pick your evening",
      step2: "2 · Number of guests",
      step3: "3 · Your details",
      seatsLeft: "seats left",
      soldOut: "Sold out",
      guests: "guests",
      name: "Name",
      email: "Email address",
      phone: "Phone (optional)",
      dietary: "Dietary requests (optional)",
      total: "Total",
      perPerson: "€75 per person",
      pay: "Continue to payment",
      processing: "Processing…",
      note: "Free cancellation up to 48 hours in advance. Secure payment via Stripe (card, iDEAL, Apple Pay).",
      cancelledToast: "Payment cancelled — your spot is not reserved yet.",
      errorToast: "Something went wrong. Please try again.",
      fillToast: "Please enter your name and a valid email address.",
    },
    practical: {
      kicker: "Practical",
      title: "Good to know",
      location: "Location",
      locationVal: "Jan Thiel Beach, Curaçao",
      times: "Days & times",
      timesVal: "Wednesday & Sunday · 3:30 PM – ~8:30 PM",
      dress: "Dress code",
      dressVal: "Casual beachwear — bring your swimwear",
      contact: "Contact",
      email: "hello@curacaobeachbbq.com",
      whatsapp: "WhatsApp us",
      faqTitle: "Frequently asked questions",
      faq: [
        { q: "What if the weather is bad?", a: "We move your booking to a next edition free of charge, or you get a full refund." },
        { q: "Can I cancel?", a: "Yes, free of charge up to 48 hours in advance. After that we can no longer refund." },
        { q: "Are children welcome?", a: "Absolutely! The vibe is family-friendly — bring swim gear." },
        { q: "Diet or allergy?", a: "Let us know when booking — our grill master will take care of it." },
        { q: "Parking?", a: "Free parking within walking distance of the beach." },
      ],
    },
    footer: {
      tag: "Beach BBQ experience on Curaçao. Fire, sea and sunset.",
      rights: "© 2026 Curaçao Beach Barbecue. All rights reserved.",
      music: "Music: “No Frills Salsa” — Kevin MacLeod, incompetech.com (CC BY 3.0)",
    },
    music: { label: "Salsa" },
    success: {
      verifying: "Verifying payment…",
      pending: "We are still waiting for your payment confirmation. Refresh this page in a minute.",
      title: "Booking confirmed",
      sub: "Show this pass when you arrive at the beach.",
      code: "Booking code",
      date: "Date",
      guests: "Guests",
      name: "Name",
      total: "Total paid",
      print: "Print or save",
      home: "Back to home",
    },
  },
  es: {
    nav: { experience: "Experiencia", included: "Todo incluido", menu: "Menú", bar: "Barra", practical: "Práctico", book: "Reservar" },
    hero: {
      tag: "Experiencia BBQ en la playa",
      kicker: "Curaçao · cada miércoles y domingo",
      l1: "FUEGO", l2: "MAR", l3: "ATARDECER",
      sub: "Una barbacoa de playa completa: parrillada mixta al carbón, bocaditos de bienvenida, cócteles, DJ y un chapuzón en el Caribe — de la tarde a la hora dorada.",
      cta: "Reserva tu lugar",
      badge: "€75 p.p. · todo incluido",
      cap: "máx. 30 invitados por noche",
      next: "Próximas ediciones",
    },
    marquee: ["PARRILLADA MIXTA", "ARROZ MORO", "SUNSET BEATS", "PLÁTANO FRITO", "VIBES CARIBEÑAS", "MÁX 30 INVITADOS", "MIÉRCOLES Y DOMINGO"],
    included: {
      kicker: "Todo incluido",
      title: "Un ticket. Toda la noche.",
      price: "€75",
      per: "por persona",
      extras: "Bebidas extra y un segundo plato BBQ se piden en el lugar.",
      items: [
        { tag: "01", title: "Plato BBQ completo", desc: "Parrillada mixta, arroz moro, plátano frito, maíz, ensalada, pan y papas." },
        { tag: "02", title: "Bocaditos de bienvenida", desc: "Recepción bajo las palmeras con aperitivos antes de la barbacoa." },
        { tag: "03", title: "1 cóctel", desc: "U otra bebida alcohólica a tu elección al llegar." },
        { tag: "04", title: "3 refrescos", desc: "Tres bebidas frescas incluidas — como el Coco Rico, el clásico de Curaçao." },
        { tag: "05", title: "DJ & atardecer", desc: "Beats al atardecer mientras el sol cae en el mar." },
        { tag: "06", title: "Playa & baño", desc: "Sumérgete en el Caribe y relájate en la arena." },
        { tag: "07", title: "Polar y extras", desc: "Cervezas Polar bien frías y más se piden en el lugar." },
      ],
    },
    menu: {
      kicker: "El plato BBQ",
      title: "Directo de la parrilla de carbón",
      sub: "Todo se asa en el momento y se sirve a tu gusto.",
      items: [
        { name: "Parrillada Mixta", desc: "Jugosas carnes a la parrilla y pollo marinados en especias caribeñas" },
        { name: "Plátano Frito", desc: "Plátanos maduros fritos caramelizados" },
        { name: "Papas Crujientes", desc: "Papas fritas crujientes con salsa de la casa" },
        { name: "Maíz a la Parrilla", desc: "Mazorca de maíz dulce a la parrilla con mantequilla de hierbas" },
        { name: "Ensalada Caribeña", desc: "Ensalada fresca de la huerta con aderezo cítrico tropical" },
        { name: "Pan & Mantequilla de Hierbas", desc: "Pan artesanal recién horneado con mantequilla de ajo y hierbas" },
        { name: "Arroz Moro", desc: "Arroz con frijoles negros sazonado con especias tradicionales" },
      ],
    },
    bar: {
      kicker: "La barra",
      title: "Carta de bebidas",
      note: "Bebidas extra se piden en el lugar · precios indicativos",
      groups: [
        { name: "Cerveza", items: [{ name: "Polar Pilsener", price: "€3,50" }, { name: "Heineken", price: "€4,00" }, { name: "Polar Light", price: "€3,50" }] },
        { name: "Refrescos", items: [{ name: "Coco Rico", price: "€3,00" }, { name: "Chubby", price: "€2,50" }, { name: "Supermalt", price: "€3,50" }, { name: "Agua", price: "€2,50" }] },
        { name: "Vino", items: [{ name: "Vino de la casa tinto / blanco", price: "€5,00" }, { name: "Rosado", price: "€5,50" }, { name: "Prosecco", price: "€6,50" }] },
        { name: "Cócteles", items: [{ name: "Blue Curaçao", price: "€8,50" }, { name: "Piña Colada", price: "€8,50" }, { name: "Mojito", price: "€8,50" }] },
      ],
    },
    journey: {
      kicker: "Cómo se siente la noche",
      title: "De la bienvenida al atardecer",
      steps: [
        { time: "3:30 PM", tag: "Bienvenida", title: "Llegada a la playa", desc: "Bocaditos de bienvenida y bebidas frías bajo las palmeras." },
        { time: "4:30 PM", tag: "Explosión de sabor", title: "El plato BBQ completo", desc: "Parrillada mixta recién asada, arroz moro, plátano frito, papas y ensalada." },
        { time: "6:00 PM", tag: "Vibes & chapuzón", title: "Música & baño", desc: "Un chapuzón refrescante en el Caribe al ritmo de nuestro DJ." },
        { time: "7:15 PM", tag: "Magia", title: "Hora dorada", desc: "El espectacular atardecer de Curaçao con cóctel en mano." },
      ],
    },
    booking: {
      kicker: "Reservas",
      title: "Asegura tu lugar en la playa",
      step1: "1 · Elige tu noche",
      step2: "2 · Número de invitados",
      step3: "3 · Tus datos",
      seatsLeft: "lugares libres",
      soldOut: "Agotado",
      guests: "invitados",
      name: "Nombre",
      email: "Correo electrónico",
      phone: "Teléfono (opcional)",
      dietary: "Peticiones dietéticas (opcional)",
      total: "Total",
      perPerson: "€75 por persona",
      pay: "Ir al pago",
      processing: "Procesando…",
      note: "Cancelación gratuita hasta 48 horas antes. Pago seguro con Stripe (tarjeta, iDEAL, Apple Pay).",
      cancelledToast: "Pago cancelado — tu lugar aún no está reservado.",
      errorToast: "Algo salió mal. Inténtalo de nuevo.",
      fillToast: "Introduce tu nombre y un correo válido.",
    },
    practical: {
      kicker: "Práctico",
      title: "Bueno saber",
      location: "Ubicación",
      locationVal: "Jan Thiel Beach, Curaçao",
      times: "Días y horarios",
      timesVal: "Miércoles y domingo · 3:30 PM – ~8:30 PM",
      dress: "Código de vestimenta",
      dressVal: "Ropa de playa casual — trae tu traje de baño",
      contact: "Contacto",
      email: "hello@curacaobeachbbq.com",
      whatsapp: "Escríbenos por WhatsApp",
      faqTitle: "Preguntas frecuentes",
      faq: [
        { q: "¿Qué pasa si llueve?", a: "Movemos tu reserva a la siguiente edición sin costo, o te devolvemos el importe completo." },
        { q: "¿Puedo cancelar?", a: "Sí, gratis hasta 48 horas antes. Después no podemos reembolsar." },
        { q: "¿Los niños son bienvenidos?", a: "¡Claro! El ambiente es familiar — trae ropa de baño." },
        { q: "¿Dieta o alergia?", a: "Indícalo al reservar — nuestro parrillero lo tendrá en cuenta." },
        { q: "¿Estacionamiento?", a: "Estacionamiento gratuito a pocos pasos de la playa." },
      ],
    },
    footer: {
      tag: "Experiencia Beach BBQ en Curaçao. Fuego, mar y atardecer.",
      rights: "© 2026 Curaçao Beach Barbecue. Todos los derechos reservados.",
      music: "Música: “No Frills Salsa” — Kevin MacLeod, incompetech.com (CC BY 3.0)",
    },
    music: { label: "Salsa" },
    success: {
      verifying: "Verificando el pago…",
      pending: "Aún esperamos la confirmación de tu pago. Actualiza la página en un minuto.",
      title: "Reserva confirmada",
      sub: "Muestra este pase al llegar a la playa.",
      code: "Código de reserva",
      date: "Fecha",
      guests: "Invitados",
      name: "Nombre",
      total: "Total pagado",
      print: "Imprimir o guardar",
      home: "Volver al inicio",
    },
  },
  pap: {
    nav: { experience: "Eksperensia", included: "Tur inkluí", menu: "Menu", bar: "Bar", practical: "Praktiko", book: "Reservá" },
    hero: {
      tag: "Eksperensia BBQ na playa",
      kicker: "Kòrsou · tur djarason & djadomingu",
      l1: "KANDELA", l2: "LAMAN", l3: "ATARDESER",
      sub: "Un barbeku kompletu na playa: mixed grill riba karbon, snack di bienvenida, cocktail, ritmo di DJ i un zambuya den laman Karibe — for di atardi te ora di solo baha.",
      cta: "Reservá bo lugá",
      badge: "€75 p.p. · tur inkluí",
      cap: "máks. 30 invitado pa anochi",
      next: "Siguiente edishonnan",
    },
    marquee: ["MIXED GRILL", "AROS MORO", "SUNSET BEATS", "BAKABANA", "VIBES KARIBENSE", "MÁKS 30 INVITADO", "DJARASON & DJADOMINGU"],
    included: {
      kicker: "Tur inkluí",
      title: "Un ticket. Henter e anochi.",
      price: "€75",
      per: "pa persona",
      extras: "Bebida ekstra i un di dos BBQ-plate bo por pidi na e lugá.",
      items: [
        { tag: "01", title: "BBQ-plate yena", desc: "Mixed grill, aros moro, bakabana, maishi, salada, pan i patat." },
        { tag: "02", title: "Snack di bienvenida", desc: "Bienvenida bou di e palmanan ku snack promé ku e barbeku." },
        { tag: "03", title: "1 cocktail", desc: "Of un otro bebida alkohóliko di bo preferensia na yegada." },
        { tag: "04", title: "3 refresko", desc: "Tres bebida frisko inkluí — manera Coco Rico, e klásiko di Kòrsou." },
        { tag: "05", title: "DJ & atardeser", desc: "Ritmo di atardeser mientras solo ta baha den laman." },
        { tag: "06", title: "Playa & zambuya", desc: "Zambuya den laman Karibe i reláha riba e santu." },
        { tag: "07", title: "Polar & ekstra", desc: "Serbes Polar frisku i mas bo por pidi na e lugá." },
      ],
    },
    menu: {
      kicker: "E BBQ-plate",
      title: "Direk for di e grill di karbon",
      sub: "Tur kos ta wòrdu grillá na e momentu i serbi manera bo ke.",
      items: [
        { name: "Mixed Grill", desc: "Karné premium i galinja suave grillá, mariná den spisia Karibense" },
        { name: "Bakabana", desc: "Bakabana dushi karamelisá" },
        { name: "Patat Krespi", desc: "Patat krespi serbi ku salsa di kas" },
        { name: "Maishi Grillá", desc: "Maishi dushi grillá riba karbon ku manteka di yerba" },
        { name: "Salada Karibense", desc: "Salada fresku ku dressing tropikal di sitrus" },
        { name: "Pan & Manteka di Yerba", desc: "Pan fresku ku manteka kremoso di konoflòi i yerba" },
        { name: "Aros Moro", desc: "Aros tradishonal sazoná ku bonchi pretu i aroma sabroso" },
      ],
    },
    bar: {
      kicker: "E bar",
      title: "Karta di bebida",
      note: "Bebida ekstra bo ta pidi na e lugá · preis indikatí",
      groups: [
        { name: "Serbes", items: [{ name: "Polar Pilsener", price: "€3,50" }, { name: "Heineken", price: "€4,00" }, { name: "Polar Light", price: "€3,50" }] },
        { name: "Refresko", items: [{ name: "Coco Rico", price: "€3,00" }, { name: "Chubby", price: "€2,50" }, { name: "Supermalt", price: "€3,50" }, { name: "Awa", price: "€2,50" }] },
        { name: "Biña", items: [{ name: "Biña di kas kòrá / blanku", price: "€5,00" }, { name: "Rosé", price: "€5,50" }, { name: "Prosecco", price: "€6,50" }] },
        { name: "Cocktail", items: [{ name: "Blue Curaçao", price: "€8,50" }, { name: "Piña Colada", price: "€8,50" }, { name: "Mojito", price: "€8,50" }] },
      ],
    },
    journey: {
      kicker: "Kon e anochi ta sinti",
      title: "For di bienvenida te atardeser",
      steps: [
        { time: "15:30", tag: "Bienvenida", title: "Yegada na playa", desc: "Snack di bienvenida i bebida frisko bou di e palmanan." },
        { time: "16:30", tag: "Explosión di gusto", title: "E BBQ-plate yena", desc: "Mixed grill fresku for di grill, aros moro, bakabana, patat i salada." },
        { time: "18:00", tag: "Vibes & zambuya", title: "Musika & zambuya", desc: "Un zambuya refreskante den laman Karibe riba e ritmo di nos DJ." },
        { time: "19:15", tag: "Magia", title: "Ora di oro", desc: "E spektakulár atardeser di Kòrsou ku cocktail den man." },
      ],
    },
    booking: {
      kicker: "Reservashon",
      title: "Sigurá bo lugá na playa",
      step1: "1 · Skohe bo anochi",
      step2: "2 · Kuantità di invitado",
      step3: "3 · Bo datonan",
      seatsLeft: "lugá liber",
      soldOut: "Yena",
      guests: "invitado",
      name: "Nòmber",
      email: "E-mail",
      phone: "Telefòn (opsional)",
      dietary: "Deseo di dieta (opsional)",
      total: "Total",
      perPerson: "€75 pa persona",
      pay: "Bai paga",
      processing: "Prosesando…",
      note: "Kanselá gratis te 48 ora promé. Pago sigur via Stripe (tarjeta, iDEAL, Apple Pay).",
      cancelledToast: "Pago kanselá — bo lugá no ta reservá ainda.",
      errorToast: "Algu a bai robes. Purba atrobe.",
      fillToast: "Yena bo nòmber i un e-mail válido.",
    },
    practical: {
      kicker: "Praktiko",
      title: "Bon pa sa",
      location: "Lugá",
      locationVal: "Jan Thiel Beach, Kòrsou",
      times: "Dia & orario",
      timesVal: "Djarason & djadomingu · 15:30 – ±20:30",
      dress: "Dresscode",
      dressVal: "Beachwear kasual — hiba bo paña di landa",
      contact: "Kontakto",
      email: "hello@curacaobeachbbq.com",
      whatsapp: "Manda nos WhatsApp",
      faqTitle: "Pregunta frekuente",
      faq: [
        { q: "Kiko si e tempu ta malu?", a: "Nos ta move bo reservashon gratis pa un siguiente edishon, of bo ta haña bo plaka bèk kompletu." },
        { q: "Mi por kanselá?", a: "Si, gratis te 48 ora promé. Despùs lamentablemente nos no por devolve plaka." },
        { q: "Muchanan ta bonbiní?", a: "Sigur! E ambiente ta pa famia — hiba paña di landa." },
        { q: "Dieta of alergia?", a: "Menchoné na momento di reservá — nos grillmeister ta tene kuenta kuné." },
        { q: "Parking?", a: "Parking gratis na distansia di kana for di e playa." },
      ],
    },
    footer: {
      tag: "Eksperensia Beach BBQ na Kòrsou. Kandela, laman i atardeser.",
      rights: "© 2026 Curaçao Beach Barbecue. Tur derechi reservá.",
      music: "Musika: “No Frills Salsa” — Kevin MacLeod, incompetech.com (CC BY 3.0)",
    },
    music: { label: "Salsa" },
    success: {
      verifying: "Verifikando pago…",
      pending: "Nos ainda ta warda riba konfirmashon di bo pago. Rekarga e página den un minüt.",
      title: "Reservashon konfirmá",
      sub: "Mustra e pase aki na yegada na playa.",
      code: "Kódigo di reservashon",
      date: "Fecha",
      guests: "Invitado",
      name: "Nòmber",
      total: "Total paga",
      print: "Print of warda",
      home: "Bai bèk na home",
    },
  },
};

const LOCALES = { nl: "nl-NL", en: "en-GB", es: "es-ES", pap: ["pap-CW", "nl-NL"] };

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("cbb-lang") || "nl");
  const setLang = (l) => {
    localStorage.setItem("cbb-lang", l);
    setLangState(l);
  };
  const value = { lang, setLang, t: translations[lang], locale: LOCALES[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
